import {
  GET_AUDIT_LOGS_REQUEST,
  GET_AUDIT_LOGS_SUCCESS,
  GET_AUDIT_LOGS_FAIL,
  GET_AUDIT_LOGS_RESET,
  GET_AUDIT_LOG_BY_ID_REQUEST,
  GET_AUDIT_LOG_BY_ID_SUCCESS,
  GET_AUDIT_LOG_BY_ID_FAIL,
  GET_AUDIT_LOG_BY_ID_RESET,
  GET_AUDIT_LOG_STATS_REQUEST,
  GET_AUDIT_LOG_STATS_SUCCESS,
  GET_AUDIT_LOG_STATS_FAIL,
  GET_PENDING_REVIEWS_REQUEST,
  GET_PENDING_REVIEWS_SUCCESS,
  GET_PENDING_REVIEWS_FAIL,
  MARK_AS_REVIEWED_REQUEST,
  MARK_AS_REVIEWED_SUCCESS,
  MARK_AS_REVIEWED_FAIL,
  MARK_AS_REVIEWED_RESET,
  GET_SECURITY_ALERTS_REQUEST,
  GET_SECURITY_ALERTS_SUCCESS,
  GET_SECURITY_ALERTS_FAIL,
  GET_USER_ACTIVITY_REQUEST,
  GET_USER_ACTIVITY_SUCCESS,
  GET_USER_ACTIVITY_FAIL,
  EXPORT_AUDIT_LOGS_REQUEST,
  EXPORT_AUDIT_LOGS_SUCCESS,
  EXPORT_AUDIT_LOGS_FAIL,
  BULK_MARK_REVIEWED_REQUEST,
  BULK_MARK_REVIEWED_SUCCESS,
  BULK_MARK_REVIEWED_FAIL,
  BULK_MARK_REVIEWED_RESET,
} from '../constants/auditTrailConstants'

export const auditLogsReducer = (state = { logs: [], total: 0, page: 1, pages: 1 }, action) => {
  switch (action.type) {
    case GET_AUDIT_LOGS_REQUEST:
      return { ...state, loading: true }
    case GET_AUDIT_LOGS_SUCCESS:
      return {
        loading: false,
        logs: action.payload.logs,
        total: action.payload.total,
        page: action.payload.page,
        pages: action.payload.pages,
      }
    case GET_AUDIT_LOGS_FAIL:
      return { ...state, loading: false, error: action.payload }
    case GET_AUDIT_LOGS_RESET:
      return { logs: [], total: 0, page: 1, pages: 1 }
    default:
      return state
  }
}

export const auditLogDetailReducer = (state = { log: null }, action) => {
  switch (action.type) {
    case GET_AUDIT_LOG_BY_ID_REQUEST:
      return { loading: true }
    case GET_AUDIT_LOG_BY_ID_SUCCESS:
      return { loading: false, log: action.payload }
    case GET_AUDIT_LOG_BY_ID_FAIL:
      return { loading: false, error: action.payload }
    case GET_AUDIT_LOG_BY_ID_RESET:
      return { log: null }
    default:
      return state
  }
}

export const auditLogStatsReducer = (state = { stats: null }, action) => {
  switch (action.type) {
    case GET_AUDIT_LOG_STATS_REQUEST:
      return { loading: true }
    case GET_AUDIT_LOG_STATS_SUCCESS:
      return { loading: false, stats: action.payload }
    case GET_AUDIT_LOG_STATS_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const pendingReviewsReducer = (state = { logs: [], total: 0, page: 1, pages: 1 }, action) => {
  switch (action.type) {
    case GET_PENDING_REVIEWS_REQUEST:
      return { ...state, loading: true }
    case GET_PENDING_REVIEWS_SUCCESS:
      return {
        loading: false,
        logs: action.payload.logs,
        total: action.payload.total,
        page: action.payload.page,
        pages: action.payload.pages,
      }
    case GET_PENDING_REVIEWS_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const markAsReviewedReducer = (state = {}, action) => {
  switch (action.type) {
    case MARK_AS_REVIEWED_REQUEST:
      return { loading: true }
    case MARK_AS_REVIEWED_SUCCESS:
      return { loading: false, success: true, data: action.payload }
    case MARK_AS_REVIEWED_FAIL:
      return { loading: false, error: action.payload }
    case MARK_AS_REVIEWED_RESET:
      return {}
    default:
      return state
  }
}

export const securityAlertsReducer = (state = { logs: [], total: 0, page: 1, pages: 1 }, action) => {
  switch (action.type) {
    case GET_SECURITY_ALERTS_REQUEST:
      return { ...state, loading: true }
    case GET_SECURITY_ALERTS_SUCCESS:
      return {
        loading: false,
        logs: action.payload.logs,
        total: action.payload.total,
        page: action.payload.page,
        pages: action.payload.pages,
      }
    case GET_SECURITY_ALERTS_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const userActivityReducer = (state = { logs: [], total: 0, page: 1, pages: 1 }, action) => {
  switch (action.type) {
    case GET_USER_ACTIVITY_REQUEST:
      return { ...state, loading: true }
    case GET_USER_ACTIVITY_SUCCESS:
      return {
        loading: false,
        logs: action.payload.logs,
        total: action.payload.total,
        page: action.payload.page,
        pages: action.payload.pages,
      }
    case GET_USER_ACTIVITY_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const exportAuditLogsReducer = (state = {}, action) => {
  switch (action.type) {
    case EXPORT_AUDIT_LOGS_REQUEST:
      return { loading: true }
    case EXPORT_AUDIT_LOGS_SUCCESS:
      return { loading: false, success: true }
    case EXPORT_AUDIT_LOGS_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const bulkMarkReviewedReducer = (state = {}, action) => {
  switch (action.type) {
    case BULK_MARK_REVIEWED_REQUEST:
      return { loading: true }
    case BULK_MARK_REVIEWED_SUCCESS:
      return { loading: false, success: true, data: action.payload }
    case BULK_MARK_REVIEWED_FAIL:
      return { loading: false, error: action.payload }
    case BULK_MARK_REVIEWED_RESET:
      return {}
    default:
      return state
  }
}
